import { Component, OnInit, ChangeDetectionStrategy, input, inject } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { TaskCategoryService } from '@fitness-force/api';
import type { ListTaskCategoryResponse, TaskCategoryResponse, TENANTSINTERFACE } from '@fitness-force/models';
import { SelectModule } from 'primeng/select';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from '@fitness-force/state';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'task-category',
  templateUrl: './task-category-dropdown.component.html',
  styleUrls: ['./task-category-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    MultiSelectModule,
    AsyncPipe
]
})
export class TaskCategoryDropdownComponent implements OnInit {
  private store = inject(Store);
  private taskCategoryService = inject(TaskCategoryService);

  readonly formGroup = input<UntypedFormGroup>(new UntypedFormGroup({}));
  readonly controlName = input<UntypedFormControl>(new UntypedFormControl());
  readonly placeHolder = input<string>('Select');
  readonly multi = input(false);
  readonly styleClass = input<string>('-ml-2 border-none surface-50 w-full text-smtext-sm');
  readonly categoryId = input<number>(0);
 
  taskCategory$ = new BehaviorSubject<TaskCategoryResponse[]>([]);

  ngOnInit() {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      if (tenant.selected_tenant && tenant.selected_tenant.id > 0) {
        this.getTaskCategory(tenant.selected_tenant.id);
      }
    });
  }

  getTaskCategory(tenantId: number): void {
    this.taskCategoryService
      .getTaskCategory(tenantId)
      .subscribe((data: ListTaskCategoryResponse) => {
        let odata = data.items.filter((o: TaskCategoryResponse) => {
          return String(o.status).toLowerCase() == 'active';
        });
        this.taskCategory$.next(odata);
        if(this.categoryId() > 0) this.controlName().setValue(odata.find(o => o.id == this.categoryId())!);
      });
  }



  get TaskCategory(): any {
    return this.controlName()?.value;
  }

}
